/**
 * JT Assets services
 *
 * Contact: apiteam@swagger.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ErrorResponseData } from '../model/errorResponseData';
// @ts-ignore
import { GetCodetableAddressesReq } from '../model/getCodetableAddressesReq';
// @ts-ignore
import { GetCodetableCurrencyRespInner } from '../model/getCodetableCurrencyRespInner';
// @ts-ignore
import { SuggestedAddress } from '../model/suggestedAddress';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class CodetablesService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get addresses
     * Get one or more addresses based on full or partial match of search parameters.
     * @param jtaTransactionId Unique identification of the transaction within the system.
     * @param getCodetableAddressesReq 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCodetableAddresses(jtaTransactionId: string, getCodetableAddressesReq: GetCodetableAddressesReq, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<SuggestedAddress>>;
    public getCodetableAddresses(jtaTransactionId: string, getCodetableAddressesReq: GetCodetableAddressesReq, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<SuggestedAddress>>>;
    public getCodetableAddresses(jtaTransactionId: string, getCodetableAddressesReq: GetCodetableAddressesReq, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<SuggestedAddress>>>;
    public getCodetableAddresses(jtaTransactionId: string, getCodetableAddressesReq: GetCodetableAddressesReq, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (jtaTransactionId === null || jtaTransactionId === undefined) {
            throw new Error('Required parameter jtaTransactionId was null or undefined when calling getCodetableAddresses.');
        }
        if (getCodetableAddressesReq === null || getCodetableAddressesReq === undefined) {
            throw new Error('Required parameter getCodetableAddressesReq was null or undefined when calling getCodetableAddresses.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (jtaTransactionId !== undefined && jtaTransactionId !== null) {
            localVarHeaders = localVarHeaders.set('jta-transaction-id', String(jtaTransactionId));
        }

        // authentication (bearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/codetables/address`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<SuggestedAddress>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: getCodetableAddressesReq,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get exchange rates
     * Get current exchange rates.
     * @param jtaTransactionId Unique identification of the transaction within the system.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCodetableCurrency(jtaTransactionId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<GetCodetableCurrencyRespInner>>;
    public getCodetableCurrency(jtaTransactionId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<GetCodetableCurrencyRespInner>>>;
    public getCodetableCurrency(jtaTransactionId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<GetCodetableCurrencyRespInner>>>;
    public getCodetableCurrency(jtaTransactionId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (jtaTransactionId === null || jtaTransactionId === undefined) {
            throw new Error('Required parameter jtaTransactionId was null or undefined when calling getCodetableCurrency.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (jtaTransactionId !== undefined && jtaTransactionId !== null) {
            localVarHeaders = localVarHeaders.set('jta-transaction-id', String(jtaTransactionId));
        }

        // authentication (bearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/codetables/currency`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<GetCodetableCurrencyRespInner>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
